import React, { Component } from 'react'
import ExportPDF from './components/ExportPDF'


export class ThesisActivityExportPDF extends Component {
  render() {
    return (
      <ExportPDF />
    )
  }
}
